// Template mapping for different SKU patterns
export const TEMPLATE_MAPPINGS = {
  // Shinola Watch templates (S01)
  S01: [
    {
      name: "01 Watch WS Direct",
      path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/01 Watch WS Direct.btw",
      manufacturing: false
    },
    {
      name: "Item Label 1.50 x 0.5",
      path: "librarian://Main/Shinola/Distribution Center/1.5 x 0.5 Labels/1.5 x .5 Item Label.btw",
      manufacturing: false
    },
    {
      name: "Box Label (R) 4 x 2",
      path: "librarian://Main/Shinola/Manufacturing/Watches/Box Label (R) 4 x 2.btw",
      manufacturing: true
    },
    {
      name: "Watch Label Manufacturing 1.5 x 0.5",
      path: "librarian://Main/Shinola/Manufacturing/Watches/Watch Label 1.5 x 0.5.btw",
      manufacturing: false
    },
    {
      name: "East Dane Watch",
      path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/East Dane Watch.btw",
      manufacturing: false
    }
  ],

  // Shinola Leather templates (S03)
  S03: [
    {
      name: "03 Leather Sticker",
      path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/03 Leather Sticker.btw",
      manufacturing: false
    },
    {
      name: "Leather PR 1 x 1",
      path: "librarian://Main/Shinola/Material Handling/Leather PR 1 x 1.btw",
      manufacturing: true
    },
    {
      name: "No MSRP Sticker",
      path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/Leather sticker no MSRP.btw",
      manufacturing: false
    }
  ],

  // Shinola Supply and Apparel templates (S06)
  S06: [
    {
      name: "02 Supply and Jewelry Label",
      path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/02 Supply and Jewelry Label.btw",
      manufacturing: false
    },
    {
      name: "1.25x3 Price Change Label (Apparel)",
      path: "librarian://Main/Shinola/Distribution Center/Price change/1.25x3 Price Change Label (Apparel).btw",
      manufacturing: false
    },
    {
      name: "Watch Label Manufacturing 1.5 x 0.5",
      path: "librarian://Main/Shinola/Manufacturing/Watches/Watch Label 1.5 x 0.5.btw",
      manufacturing: false
    }
  ],

  // Shinola Journal templates (S07)
  S07: [
    {
      name: "1x1.25 Journal Label",
      path: "librarian://Main/Shinola/Distribution Center/1x1.25 Journal Label.btw",
      manufacturing: false
    },
    {
      name: "1 x 1 Made in China 02 Supply and Jewelry Label",
      path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/Made in China 02 Supply and Jewelry Label.btw",
      manufacturing: false
    }
  ],

  // Shinola Strap templates (S11)
  S11: [
    {
      name: "Kitting 3 x 1",
      path: "librarian://Main/Shinola/Manufacturing/Straps/Kitting 3 x 1.btw",
      manufacturing: true
    },
    {
      name: "Item Label 1.50 x 0.5",
      path: "librarian://Main/Shinola/Distribution Center/1.5 x 0.5 Labels/1.5 x .5 Item Label.btw",
      manufacturing: false
    }
  ],

  // Shinola Jewelry templates (S18)
  S18: [
    {
      name: "02 Supply and Jewelry Label",
      path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/02 Supply and Jewelry Label.btw",
      manufacturing: false
    }
  ],

  // Shinola Clock templates (S26)
  S26: [
    {
      name: "Clock Label 1.5 x 1",
      path: "librarian://Main/Shinola/Manufacturing/Clocks/Clock Label 1.5 x 1.btw",
      manufacturing: false
    }
  ],

  // Shinola Sunglasses templates (S29)
  S29: [
    {
      name: "1.25x3 Price Change Label (Apparel)",
      path: "librarian://Main/Shinola/Distribution Center/Price change/1.25x3 Price Change Label (Apparel).btw",
      manufacturing: false
    }
  ],

  // Other Shinola templates (any other S SKUs)
  S_OTHER: [
    {
      name: "2x4 Location Labels Fixed",
      path: "librarian://Main/Shinola/Distribution Center/8.5 x 11 Labels/2x4 Location Labels Fixed.btw",
      manufacturing: false
    },
    {
      name: "8.5 x 11 - Locations 1Feb17 BK Rev 2",
      path: "librarian://Main/Shinola/Distribution Center/8.5 x 11 Labels/8.5 x 11 - Locations 1Feb17 BK Rev 2.btw",
      manufacturing: false
    },
    {
      name: "8.5 x 11- NSI",
      path: "librarian://Main/Shinola/Distribution Center/NSI/8.5 x 11- NSI.btw",
      manufacturing: false
    },
    {
      name: "Batch Control 3 x 1",
      path: "librarian://Main/Shinola/Manufacturing/Movements/Batch Control 3 x 1.btw",
      manufacturing: false
    },
    {
      name: "Buckle 1.50 x .5",
      path: "librarian://Main/Shinola/Material Handling/Buckle 1.50 x .5.btw",
      manufacturing: false
    },
    {
      name: "Chablon From Ronda 1x 1",
      path: "librarian://Main/Shinola/Material Handling/Chablon From Ronda  1x 1.btw",
      manufacturing: false
    },
    {
      name: "Chablon Label 4x2",
      path: "librarian://Main/Shinola/Manufacturing/Movements/Chablon Label 4x2.btw",
      manufacturing: false
    },
    {
      name: "Item Delivery Label 4x2",
      path: "librarian://Main/Shinola/Manufacturing/Movements/Item Delivery Label 4x2.btw",
      manufacturing: false
    },
    {
      name: "Item Label 3 x 1",
      path: "librarian://Main/Shinola/Material Handling/Item Label 3 x 1.btw",
      manufacturing: false
    },
    {
      name: "Item Label 4 x 2",
      path: "librarian://Main/Shinola/Material Handling/Item Label 4 x 2.btw",
      manufacturing: false
    },
    {
      name: "License Stickers",
      path: "librarian://Main/Shinola/Distribution Center/License Stickers.btw",
      manufacturing: false
    },
    {
      name: "Mini Traveler",
      path: "librarian://Main/Shinola/Material Handling/Mini Traveler.btw",
      manufacturing: false
    },
    {
      name: "Movement 3 x 1",
      path: "librarian://Main/Shinola/Manufacturing/Movements/Movement 3 x 1.btw",
      manufacturing: false
    },
    {
      name: "Outer Tray Label 4 x 2",
      path: "librarian://Main/Shinola/Material Handling/Outter Tray Label 4 x 2.btw",
      manufacturing: false
    },
    {
      name: "Raw Materials 1 x 1",
      path: "librarian://Main/Shinola/Material Handling/Raw Materials 1 x 1.btw",
      manufacturing: false
    },
    {
      name: "RM Movement Parts 3 x 1",
      path: "librarian://Main/Shinola/Manufacturing/Movements/RM Movement Parts 3 x 1.btw",
      manufacturing: false
    },
    {
      name: "Serial Number No Barcode",
      path: "librarian://Main/Shinola/Distribution Center/1.5 x 0.5 Labels/Serial Number No Barcode.btw",
      manufacturing: false
    },
    {
      name: "Serial Number with Barcode",
      path: "librarian://Main/Shinola/Distribution Center/1.5 x 0.5 Labels/Serial Number with Barcode.btw",
      manufacturing: false
    }
  ]
};

// Brand detection utilities
export const getBrandFromSku = (sku) => {
  if (!sku) return null;

  const firstChar = sku.charAt(0).toUpperCase();
  if (firstChar === 'S') return 'Shinola';
  if (firstChar === 'F') return 'Filson';
  return null;
};

export const getSkuCategory = (sku) => {
  if (!sku) return null;

  const upperSku = sku.toUpperCase();

  // Check for specific Shinola categories
  if (upperSku.startsWith('S01')) return 'S01';
  if (upperSku.startsWith('S03')) return 'S03';
  if (upperSku.startsWith('S06')) return 'S06';
  if (upperSku.startsWith('S07')) return 'S07';
  if (upperSku.startsWith('S11')) return 'S11';
  if (upperSku.startsWith('S18')) return 'S18';
  if (upperSku.startsWith('S26')) return 'S26';
  if (upperSku.startsWith('S29')) return 'S29';

  // If it starts with S but doesn't match specific categories
  if (upperSku.startsWith('S')) return 'S_OTHER';

  // Filson SKUs (F) don't have specific categories yet
  if (upperSku.startsWith('F')) return 'F';

  return null;
};

export const getTemplatesForSku = (sku, isNoPrice = false) => {
  const category = getSkuCategory(sku);
  if (!category) return [];

  let templates = TEMPLATE_MAPPINGS[category] || [];

  if (isNoPrice && getBrandFromSku(sku) === 'Shinola') {
    const extraTemplates = [
      {
        name: "01 Watch WS Direct",
        path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/01 Watch WS Direct.btw",
        manufacturing: false
      },
      {
        name: "02 Supply and Jewelry Label",
        path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/02 Supply and Jewelry Label.btw",
        manufacturing: false
      },
      {
        name: "03 Leather Sticker",
        path: "librarian://Main/Shinola/Distribution Center/1 x 1 Labels/03 Leather Sticker.btw",
        manufacturing: false
      }
    ];

    const existingPaths = new Set(templates.map(t => t.path));
    const toAdd = extraTemplates.filter(t => !existingPaths.has(t.path));

    if (toAdd.length > 0) {
      templates = [...templates, ...toAdd];
    }
  }

  return templates;
};

export const getSkuCategoryName = (category) => {
  const categoryNames = {
    S01: 'Watches',
    S03: 'Leather',
    S06: 'Supply and Apparel',
    S07: 'Journal',
    S11: 'Strap',
    S18: 'Jewelry',
    S26: 'Clock',
    S29: 'Sunglasses',
    S_OTHER: 'Other Shinola Products',
    F: 'Filson Products'
  };

  return categoryNames[category] || category;
};

// Check if SKU should show orientation selection (only Filson)
export const shouldShowOrientation = (sku) => {
  const brand = getBrandFromSku(sku);
  return brand === 'Filson';
};

// Get default template for Filson (existing logic)
export const getFilsonTemplateByOrientation = (orientation) => {
  if (orientation === '90') {
    return 'librarian://Main/Filson/FCO/Retail/Filson Hangtag(90).btw';
  } else if (orientation === '180') {
    return 'librarian://Main/Filson/FCO/Retail/US Hangtag (180).btw';
  } else {
    return 'librarian://Main/Filson/FCO/Retail/Filson Hangtag.btw';
  }
};

